import { memo } from 'react';
import { IImages } from '../../../mechanics/characters/Character';
import ImgWithFallback from '../../ui/ImgWithFallback';

interface IUserCharactersAliveProps {
    img: IImages,
    playerHp: number
    maxHp: number
    widthHpBar: number
}

const UserCharactersAlive = ({ img, playerHp, maxHp, widthHpBar }: IUserCharactersAliveProps) => {
    return (
        <>
            <ImgWithFallback src={img.webp} fallbackSrc={img.img} classNames={'player__content-img'} />
            <div className="player__content-hp">
                <span style={{ width: `${widthHpBar}%` }}></span>
                <p>{playerHp} / {maxHp}</p>
            </div>
        </>
    );
};

export default memo(UserCharactersAlive);